const LOCKED_ROUTE_PREFIXES: string[] = [
  // Eventos
  '/dashboard/management/events/create',
  '/dashboard/management/events/edit',
  '/dashboard/management/events/tickets/list',
  '/dashboard/management/events/tickets/redimidor',
  '/dashboard/management/events/tickets/reversed-tickets',
  '/dashboard/management/events/ticketsTypes/list',
  '/dashboard/management/events/ticketsTypes/create',
  '/dashboard/management/events/statistics/list',
  '/dashboard/management/events/statistics/gift',
  '/dashboard/management/events/statistics/referenced-rrpp',
  '/dashboard/management/events/statistics/direct-rrpp',
  '/dashboard/management/events/statistics/producer',
  '/dashboard/management/events/statistics/loyalty',
  '/dashboard/management/events/tickets/sell-ticket',


  // Etiquetas
  '/dashboard/management/tags/create',
  '/dashboard/management/tags/edit',

  // Usuarios
  '/dashboard/management/users/create',
  '/dashboard/management/users/edit',

  // Notificaciones
  '/dashboard/management/notifications/create',
  '/dashboard/management/notifications/edit',

  // Roles
  '/dashboard/management/roles/create',
  '/dashboard/management/roles/edit',

  // Ubicaciones (Places)
  '/dashboard/management/places/create',
  '/dashboard/management/places/edit',

  // Novedades
  '/dashboard/management/news/edit',
  '/dashboard/management/news/create',

  //massive
  '/dashboard/management/events/tickets/create',

  //sell
  '/dashboard/management/events/tickets/sell'
];

// Dado un pathname completo (location.pathname),
// indica si el selector de productora debe estar bloqueado.
export const isProducerSelectorLockedPath = (pathname: string): boolean => {
  if (!pathname) return false;

  return LOCKED_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};
